module.exports = {
  "source": ".ConsumerButton__button___2-nAh{\n  max-width:100%;\n  padding:13px 0;\n  text-decoration:none;\n  font-family:\"BentonSans-Re\";\n  font-size:1pc;\n  line-height:23px;\n  font-weight:400;\n  color:#fff;\n  letter-spacing:-.3px;\n  background-color:#1274b8;\n  border:1px solid #1274b8;\n  display:block;\n  text-align:center;\n  vertical-align:middle;\n  border-radius:.25rem;\n  width:218px;\n  margin:0 auto;\n  cursor:pointer; }\n.ConsumerButton__button___2-nAh:hover{\n    background-color:#1483cf; }\n.ConsumerButton__button___2-nAh:focus{\n    outline:none; }\n@media (min-width: 768px){\n    .ConsumerButton__button___2-nAh{\n      margin:auto;\n      float:none; } }\n",
  "classNames": {
    "button": "ConsumerButton__button___2-nAh"
  },
  "classNameHash": {
    "ConsumerButton__button___2-nAh": "button"
  }
};

module.exports.getClassName = function(name, defaultValue) {
    return module.exports.classNames[name] || defaultValue;
};

module.exports.getClassNameHash = function(name, defaultValue) {
  return module.exports.classNameHash[name] || defaultValue;
};

module.exports.toString = function() {
  return module.exports.source;
};
